import React, { useEffect, useState } from 'react';
import './StallBookingDetail.scss';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { FxCurrency, http, general, formatService } from '../../fx-core';
import _ from "lodash";

const StallBookingDetail = (props: any) => {
  console.log("props", props.id);

  const defaultBookingRequest = {
    bookingDate: "",
    bookingTime: "",
    seatCount: 0,
    contactName: "",
    contactNumber: "",
    bookingRequestIdentifier: "",
    pricePerSeat: 0,
    amount: 0,
    stallName: "",
    bookingPayments: [],
    requestNotes: "",
    bookingRequestStatus: "",
    Email: ""
  };

  const [bookingRequest, setBookingRequest] = useState(defaultBookingRequest);
  const[booking, setBooking] = useState([]);

  const getBookingRequestById = () => {
    const inputData = { id: props.id };
    const apiOptions: any = { url: `stallbookingrequest/${inputData.id}` };

    http.get(apiOptions).then(res => {
            getBookingById(res.data.stallBookingId);

      getBookingRequestByIdCallBack(res);

    });
  };

  
  const getBookingRequestByIdCallBack = (res: any) => {
    const result = res.data;
    result.bookingTime = formatService.getConvertedTimeForDisplay(result.bookingTime);
    setBookingRequest(result);
  };

    const getBookingById = (stallBookingId) => {
      let apiOptions: any = {
        url: `portal/stall/booking/${stallBookingId}`,
        data: {}
      };
      http.get(apiOptions).then(res => {
        setBooking(res.data);
        console.log("booking", res.data);
      });
    };

  const handleClose = () => {
    props.handleClose();
  };

  useEffect(() => {
    getBookingRequestById();
  }, []);

  // 🧮 Compute totals and coupon values
  const totalPrice = bookingRequest.seatCount * bookingRequest.pricePerSeat;

  const couponPayment = bookingRequest.bookingPayments.find((p: any) => p.paymentMode === "coupon");
  const couponAmount = couponPayment ? couponPayment.amount : 0;
  const finalAmount = totalPrice - couponAmount;

  const body = (
    <div className="stall-booking-detail">
      <div className="row col-12 title-font py-1 mx-auto">
        <div className="col-11 pl-0">
          <span>Booking Detail</span>
        </div>
        <div className="col-1 text-right pointer px-0" onClick={handleClose}>
          <HighlightOffIcon fontSize="small" color="secondary" />
        </div>
      </div>

      {/* Desktop View */}
      <div className="deskview">
        <div className="row mr-3 my-3 ml-0">
          <div className="col-12 summary-detail font-14">

            <div className="row">
              <div className="col-4">Booking #</div>
              <div className="col-8">: {bookingRequest.bookingRequestIdentifier}</div>
            </div>

            <div className="row pt-1">
              <div className="col-4">Session Date</div>
              <div className="col-8">: {general.getFormattedDate(bookingRequest.bookingDate)}</div>
            </div>

            <div className="row pt-1">
              <div className="col-4">Session Time</div>
              <div className="col-8">: {bookingRequest.bookingTime}</div>
            </div>
            {/* Booking Mode / Venue + Duration */}
{booking.bookingModeId && (
  <>
    <div className="row pt-1">
      <div className="col-4">
        {booking.bookingModeId === 1 ? "Booking Venue" : "Booking Mode"}
      </div>
      <div className="col-8">
        :
        {booking.bookingModeId === 1
          ? booking.venueDetail
          : booking.bookingModeId === 2
          ? "Online"
          : "N/A"}
      </div>
    </div>

    <div className="row pt-1">
      <div className=" col-4">Duration</div>
      <div className="col-8">
        :
        {booking.durationInMins}{" "}
        {booking.deliveryTimeUnits === 1
          ? "Minutes"
          : booking.deliveryTimeUnits === 2
          ? "Hours"
          : booking.deliveryTimeUnits === 3
          ? "Days"
          : "Minutes"}
      </div>
    </div>
  </>
)}


{booking.bookingModeId === 2 && booking.url && (
  <div className="row pt-1">
      <div className="  col-4">URL </div>
      <div className="col-8">
        
        <a
          href={booking.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
            wordBreak: "break-all",
          }}
        >
             :{booking.url}
        </a>
      </div>
  </div>
)}

            <div className="row pt-1">
              <div className="col-4">Contact Name</div>
              <div className="col-8">: {bookingRequest.contactName}</div>
            </div>

            <div className="row pt-1">
              <div className="col-4">Contact Number</div>
              <div className="col-8">: {bookingRequest.contactNumber}</div>
            </div>

            {bookingRequest.requestNotes && (
              <div className="row pt-1">
                <div className="col-4">Notes</div>
                <div className="col-8">: {bookingRequest.requestNotes}</div>
              </div>
            )}

            {bookingRequest.bookingRequestStatus && (
              <div className="row pt-1">
                <div className="col-4">Status</div>
                <div className="col-8">: {bookingRequest.bookingRequestStatus}</div>
              </div>
            )}

            <div className="row pt-1">
              <div className="col-4">Seat Count</div>
              <div className="col-8">: {bookingRequest.seatCount}</div>
            </div>

            <div className="row pt-1">
              <div className="col-4">Price per Seat</div>
              <div className="col-8">: <FxCurrency value={bookingRequest.pricePerSeat} /></div>
            </div>

            <div className="row pt-1">
              <div className="col-4">Booking Amount</div>
              <div className="col-8">: <FxCurrency value={totalPrice} /></div>
            </div>

            {couponAmount > 0 && (
              <div className="row pt-1 ">
                <div className="col-4">Coupon Discount</div>
                <div className="col-8">: <FxCurrency value={couponAmount} /></div>
              </div>
            )}

            <div className="row pt-1 font-weight-bold border-top mt-2 pt-2">
              <div className="col-4">Total Payable</div>
              <div className="col-8">: <FxCurrency value={finalAmount} /></div>
            </div>

            {/* Payment Details */}
            <div className="border-top mt-3 pt-2">
              <strong>Payment Details:</strong>
              {bookingRequest.bookingPayments.map((item: any, idx: number) => (
                <div key={idx} className="mt-2">
                  {item.email && (
                    <div className="row pt-1">
                      <div className="col-4">Email</div>
                      <div className="col-8">: {item.email}</div>
                    </div>
                  )}

                  <div className="row pt-1">
                    <div className="col-4">Payment Mode</div>
                    <div className="col-8">: {item.paymentMode}</div>
                  </div>

                  <div className="row pt-1">
                    <div className="col-4">Payment Amount</div>
                    <div className="col-8">: <FxCurrency value={item.amount} /></div>
                  </div>

                  <div className="row pt-1">
                    <div className="col-4">Payment Status</div>
                    <div className="col-8">: {item.paymentStatus}</div>
                  </div>
                </div>              
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return <div>{body}</div>;
};

export default StallBookingDetail;
